function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function NotificationActive(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.57 1.033a9.528 9.528 0 00-.745-.025c-.368-.025-.714.013-1.06.051l-.097.01a7.723 7.723 0 00-2.043.508c-2.207.872-3.769 2.865-4.283 5.466-.175.891-.158 1.776-.14 2.633v.019c.005.246.01.49.01.732v2.878c0 1-.206 1.316-.609 1.576-1.038.67-1.902 1.987-1.505 3.374.188.772.713 1.596 1.623 1.596h16.2c.91 0 1.436-.824 1.614-1.558.407-1.425-.457-2.741-1.495-3.412-.403-.26-.608-.576-.608-1.576V11.98a7.95 7.95 0 01-2-.403v1.728c0 1.058.173 2.383 1.521 3.256.419.269.779.763.649 1.222a.83.83 0 01-.023.068H4.064a1.862 1.862 0 01-.033-.106c-.12-.421.241-.915.658-1.184 1.35-.873 1.522-2.198 1.522-3.256v-2.878c0-.253-.004-.51-.01-.767v-.02c-.016-.786-.03-1.528.103-2.208.223-1.13.917-3.15 3.056-3.996a5.855 5.855 0 011.833-.402l.632-.026c.08-.002.158-.002.236 0 .086-.69.26-1.351.51-1.975zm2.111 20.91a1 1 0 00-1-1H9.962a1 1 0 100 2h3.72a1 1 0 001-1z",
    fill: props.color || "#222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4z",
    fill: "#F81B40"
  }));
}
const MemoNotificationActive = /*#__PURE__*/React.memo(NotificationActive);
export default MemoNotificationActive;